import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useAuth } from '@/app/providers/auth-provider.js';
import { appPaths } from '@/app/router/paths.js';
import { canViewPlaceConfig } from '@/features/identity/place-config-access.js';

export function RequirePlaceConfigView({ children }: { children: ReactNode }) {
  const { status, user } = useAuth();

  if (status === 'loading') {
    return null;
  }

  if (status !== 'authenticated' || !user) {
    return <Navigate to={appPaths.login} replace />;
  }

  if (!canViewPlaceConfig(user.roles)) {
    return <Navigate to={appPaths.home} replace />;
  }

  return children;
}
